import payOrder from '@/view/pay/payOrder/index.vue'
import tempContractPay from '@/view/pay/tempContractPay/index.vue'


export default [
    {path: '/biz/payOrder',name: 'payOrder', component: payOrder, meta: '支付订单管理'},
    {path: '/biz/tempContractPay', name: 'tempContractPay', component: tempContractPay, meta: '协议支付'},

]
